import TweenMax from 'gsap/TweenMax';

class LongSwim {
  _initialX: number;
  _initialY: number;
  _animationCounter: number;
  constructor() {
    this._initialX = 0;
    this._initialY = 0;
    this._animationCounter = 0;
  }

  resetAnimationData() {
    this._animationCounter = 0;
  }

  animate(container, canvas, duration, beforeAnimation) {
    let {
      height: containerHeight,
      bottom: containerBottom,
      left: containerLeft,
      width: containerWidth,
    } = container.getBoundingClientRect();

    const {
      top: canvasTop,
      height: canvasHeight,
      left: canvasLeft,
      width: canvasWidth,
    } = canvas.getBoundingClientRect();

    if (this._animationCounter > 1) {
      TweenMax.set(container, {
        x: 0,
        y: 0,
      });

      ({
        height: containerHeight,
        bottom: containerBottom,
        left: containerLeft,
        width: containerWidth,
      } = container.getBoundingClientRect());

      this._animationCounter = 0;
    }

    if (this._animationCounter === 0) {
      this._initialX = canvasLeft - containerLeft;
      this._initialY =
        canvasTop -
        containerBottom +
        ((40 / 100) * canvasHeight - containerHeight);

      beforeAnimation(this._initialX, this._initialY);

      this._initialX += (canvasWidth - containerWidth) / 2;

      TweenMax.to(container, 0.25, {
        opacity: 1,
        onComplete: () => {
          TweenMax.to(container, duration - 0.25, {
            x: this._initialX,
          });
        },
      });
    } else {
      this._initialX += (canvasWidth - containerWidth) / 2;
      TweenMax.to(container, duration - 0.25, {
        x: this._initialX,
        onComplete() {
          TweenMax.to(container, 0.25, { opacity: 0 });
        },
      });
    }

    this._animationCounter++;
  }
}

export default LongSwim;
